export const downloadFileFromUrl = (url: string, fileName: string) => {
  const element = document.createElement('a');
  element.href = url;
  element.target = '_blank';
  element.download = fileName;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export const downloadFileFromBlob = (blob: Blob, fileName: string) => {
  const element = document.createElement('a');
  element.href = URL.createObjectURL(blob);
  element.target = '_blank';
  element.download = fileName;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
